import colours from "../grid/data/colours";
import { NumericFormat } from "react-number-format";
import React from "react";
import { matchPath, useLocation } from "react-router-dom";
import {
  getGridSingleSelectOperators,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes,
} from "@mui/x-data-grid";
import { TagConfig } from "./data grid files/TagConfig";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Box, styled } from "@mui/system";
import { Colours } from "../../assets/global/Theme-variable";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import CustomTextField from "../../components/CustomTextField";
import AccessControl, { checkPermissions } from "../AccessControl";
import axios from "axios";
import { API_ENDPOINTS, APP_URL } from "../../API/apiConfig";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import GridTooltip from "./DataGridRefactor/components/GridTooltip";
import EditOffIcon from "@mui/icons-material/EditOff";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import HistoryIcon from "@mui/icons-material/History";
import UpdateIcon from "@mui/icons-material/Update";
import { getUpdatedModPrice } from "./DataGridUtils";
import { cloneDeep } from "lodash";

export const initialColours = [
  "#15499F",
  "#2B74B9",
  "#478ECC",
  "#70B2E2",
  "#96C8ED",
  "#BEDEF5",
  "#0D6064",
  "#1998A7",
  "#1BBDD4",
  "#58C7DA",
  "#88D4E2",
  "#B6E2ED",
  "#0C4E42",
  "#0B7A6A",
  "#14988B",
  "#48B8AC",
  "#7FCCC6",
  "#B3E0DD",
];

// Array.prototype.random = function () {
//   return this[Math.floor(Math.random() * this.length)];
// };

export const fillList = (list) => {
  const cellCount = list.list_details.cols * list.list_details.rows;

  for (let i = 0; i < cellCount; i++) {
    const colour1 = colours.random();
    const colour2 = colours.random();

    list.config.push({
      // id: i,
      // index: i,
      // colour: colour,
      // text: "EMPTY",
      // row: 1,
      // col: 1,
      // buttonSize: "1x1",
      // textAlign: "center",
      // textColour: getTextColor(colour),
      // fontSize: 12,
      // funct: {name: "", number: ""},
      // buttonType: "PLU",

      id: i,
      index: i,
      style: {
        // colour: colour.fieldIndex,
        background: colour1.fieldIndex,
        foreground: colour2.fieldIndex,
        alignmentW: 1,
        alignmentH: 1,
        font: "10B",
      },
      text: "",
      mx: 1,
      my: 1,
      pageNo: 1,
      size: 1,
      // row: 1,
      // col: 1,
      // buttonSize: "1x1",
      // textAlign: "center",
      // textColour: getTextColor(colour),
      // fontSize: 12,
      // funct: {
      // 	name: items[i]?.text !== undefined ? items[i].text : "",
      // 	number: items[i]?.plu_number !== undefined ? items[i].plu_number : "",
      // },
      functionType: "",
      functionValue: "",
      // buttonType: "PLU",
      // boldText: false,
      hideText: 0,
    });
  }
};

export function getTextColour(
  bgColour,
  lightColour = { index: 16, colour: "#FFFFFF" },
  darkColour = { index: 1, colour: "#000000" }
) {
  const getLuminance = function (hexColour) {
    var colour =
      hexColour.charAt(0) === "#" ? hexColour.substring(1, 7) : hexColour;
    var r = parseInt(colour.substring(0, 2), 16); // hexToR
    var g = parseInt(colour.substring(2, 4), 16); // hexToG
    var b = parseInt(colour.substring(4, 6), 16); // hexToB
    var uicolours = [r / 255, g / 255, b / 255];
    var c = uicolours.map((col) =>
      col <= 0.03928 ? col / 12.92 : ((col + 0.055) / 1.055) ** 2.4
    );

    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  };

  var L = getLuminance(bgColour);
  var L1 = getLuminance(lightColour.colour);
  var L2 = getLuminance(darkColour.colour);

  return L > Math.sqrt((L1 + 0.05) * (L2 + 0.05)) - 0.05
    ? darkColour
    : lightColour;
}

export const autoFill = (list, items, colours) => {
  const cellCount = list.list_details.cols * list.list_details.rows;

  const pages =
    Math.round(items?.length / cellCount) > 0
      ? Math.round(items?.length / cellCount)
      : 1;

  let buttonArr = [];
  for (let index = 1; index <= pages; index++) {
    buttonArr.push({
      page: index,
      min: cellCount * (index - 1),
      max: cellCount * index - 1,
    });
  }
  const maxCells = cellCount * pages - 1;

  list.list_details.pages = pages;

  for (let i = 0; i <= maxCells; i++) {
    // const colour1 = colours[0].palette_details.colours.random();
    const colour1 = colours[0].palette_details.colours.find(
      (col) => col.colour === "#000000"
    );

    const colour2 = getTextColour(colour1.colour);

    list.list_details.buttons.push({
      id: i,
      index: i,
      style: {
        background: colour1.index,
        foreground: colour2.index,
        alignmentV: 1,
        alignmentH: 1,
        font: "10B",
      },
      text: items[i]?.plu_name !== undefined ? items[i].plu_name : "",
      mx: 1,
      my: 1,
      pageNo: 1,
      size: 1,
      functionType: items[i]?.plu_number !== undefined ? 21 : 0,
      functionValue:
        items[i]?.plu_number !== undefined ? parseInt(items[i].plu_number) : 0,
      hideText: 0,
    });
  }

  list.list_details.buttons.map((x, index) => {
    const page = buttonArr?.find(
      (button) => index >= button.min && index <= button.max
    );
    x.pageNo = page?.page;
  });

};

export const newPageFill = (list, items, colours) => {
  const cellCount = list.list_details.cols * list.list_details.rows;
  const pages = list.list_details.pages + 1;

  let buttonArr = [];
  for (let index = 1; index <= pages; index++) {
    buttonArr.push({
      page: index,
      min: cellCount * (index - 1),
      max: cellCount * index - 1,
    });
  }

  const maxCells = cellCount - 1;

  list.list_details.pages = pages;

  for (let i = 0; i <= maxCells; i++) {
    // const colour1 = colours[0].palette_details.colours.random();
    const colour1 = colours[0].palette_details.colours.find(
      (col) => col.colour === "#000000"
    );
    const colour2 = getTextColour(colour1.colour);
    let lastElement = list.list_details.buttons.length;
    list.list_details.buttons.push({
      id: JSON.stringify(lastElement),
      index: lastElement,
      style: {
        background: colour1.index,
        foreground: colour2.index,
        alignmentV: 1,
        alignmentH: 1,
        font: "10B",
      },
      text: items[i]?.plu_name !== undefined ? items[i].plu_name : "",
      mx: 1,
      my: 1,
      pageNo: 1,
      size: 1,
      functionType: items[i]?.plu_number !== undefined ? 21 : 0,
      functionValue:
        items[i]?.plu_number !== undefined ? parseInt(items[i].plu_number) : 0,
      hideText: 0,
    });
  }

  list.list_details.buttons.map((x, index) => {
    const page = buttonArr?.find(
      (button) => index >= button.min && index <= button.max
    );
    x.pageNo = page?.page;
    return x;
  });
};

export function groupBy(data, array, f) {
  let categories = {};
  array.forEach(function (o) {
    var category = JSON.stringify(f(o));
    categories[category] = categories[category] || [];
    categories[category].push(o);
  });
  return Object.keys(categories)
    .map(function (group) {
      let sgNo = JSON.parse(group);
      let majorGroup = data?.categories?.find(
        (group) => JSON.parse(group?.salesGroup_number) === sgNo[0]
      );

      let catName = majorGroup?.salesGroup_name;

      var group2 = {};
      group2["group"] = catName;
      group2["items"] = categories[group];
      return group2;
    })
    .filter((group) => group.group !== undefined);
}

export const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props?.name,
            value: values?.value,
          },
        });
      }}
      thousandSeparator
      decimalScale={2}
    />
  );
});

export const BarcodeFormat = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props?.name,
            value: values?.value,
          },
        });
      }}
      
      decimalScale={0}
    />
  );
});


export const makeHex = (decimalcolour) => {
  var hexColour = decimalcolour.toString(16);
  while (hexColour.length < 6) {
    hexColour = "0" + hexColour;
  }
  hexColour =
    hexColour.substring(4, 6) +
    hexColour.substring(2, 4) +
    hexColour.substring(0, 2);
  return "#" + hexColour;
};

export const debounce = (callback) => {
  let timer;

  return (...args) => {
    clearTimeout(timer);
    return new Promise((resolve) => {
      timer = setTimeout(() => resolve(callback(...args)));
    });
  };
};

export const generatePLUNumber = (lastPLU, mod) => {
  // 12230 - 12240 - correct
  // 12231 type half - 12241 - correct
  // 12231 type double - 12242 - correct

  let rounded = Math.ceil((parseInt(lastPLU) + 1) / 10) * 10;
  rounded += mod;
  // type === "standard"
  // 	? Math.ceil((lastPLU + 1) / 10) * 10
  // 	:
  // type === "half"
  // 	? Math.ceil((lastPLU + 1) / 10) * 10 + 1
  // 	: type === "double"
  // 	? Math.ceil((lastPLU + 1) / 10) * 10 + 2
  // 	: Math.ceil((lastPLU + 1) / 10) * 10;

  return JSON.stringify(rounded);
};

export function isInList(arr, plu_number) {
  return arr.some(
    (arrVal) =>
      plu_number === arrVal.functionValue && arrVal.functionType === 21
  );
}

export const appearsOn = (data, plu_number) => {
  const arr = data?.filter((list) => {
    let opt = isInList(list?.list_details?.buttons, parseInt(plu_number));
    if (opt === true) {
      return list;
    }
  });
  return arr;
};

export const sorter = (arrayToBeSorted, sortByColumn) => {
  arrayToBeSorted.sort((a, b) => {
    if (parseInt(a[sortByColumn]) < parseInt(b[sortByColumn])) return -1;
    if (parseInt(a[sortByColumn]) > parseInt(b[sortByColumn])) return 1;
    return 0;
  });
  return arrayToBeSorted;
};

export const contextDeletedFilter = (
  arrayToBeSorted,
  name,
  apiName,
  permissions
) => {
  const showDeleted = checkPermissions(permissions, {
    page: name,
    // allow: true,
    action: "undelete",
    strict: true,
  });
  let sortedArr =
    showDeleted === true
      ? arrayToBeSorted.filter(
          (a) =>
            a[`${apiName}_isDeleted`] === 0 || a[`${apiName}_isDeleted`] === 1
        )
      : arrayToBeSorted.filter((a) => a[`${apiName}_isDeleted`] === 0);
  return sortedArr;
};

export const sorterPlu = (arrayToBeSorted) => {
  arrayToBeSorted.sort((a, b) => {
    if (parseInt(a.plu_details.salesGroup) < parseInt(b.plu_details.salesGroup))
      return -1;
    if (parseInt(a.plu_details.salesGroup) > parseInt(b.plu_details.salesGroup))
      return 1;
    if (
      parseInt(a.plu_details.salesGroup) === parseInt(b.plu_details.salesGroup)
    ) {
      if (parseInt(a.plu_number) < parseInt(b.plu_number)) return -1;
      if (parseInt(a.plu_number) > parseInt(b.plu_number)) return 1;
    }

    return 0;
  });
  return arrayToBeSorted;
};

export const useRouteMatch = (patterns) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }
  return null;
};

export const setSubField = (subFieldName1, subFieldName2, subFieldName3) => {
  // The setSubField function updates a nested field with a new value
  return (params) => {
    if (subFieldName3 === undefined) {
      const field = { ...params?.row[subFieldName1] };
      field[subFieldName2] =
        typeof params?.value === "boolean" && params.value === true
          ? 1
          : typeof params?.value === "boolean" && params.value === false
          ? 0
          : params.value;

      const field2 = { ...params?.row };
      field2[subFieldName1] = field;
      return { ...field2 };
    } else {
      const field = { ...params?.row[subFieldName1] };
      field[subFieldName2][subFieldName3] =
        typeof params?.value === "boolean" && params.value === true
          ? 1
          : typeof params?.value === "boolean" && params.value === false
          ? 0
          : params.value;

      const field2 = { ...params?.row };
      field2[subFieldName1] = field;
      return { ...field2 };
    }
  };
};

export const setMajorCategory = (subFieldName1, subFieldName2) => {
  // The setSubField function updates a nested field with a new value
  return (params) => {
    const field = { ...params?.row[subFieldName1] };
    field[subFieldName2] = parseInt(params?.value);
    const field2 = { ...params?.row };
    field2[subFieldName1] = field;
    return { ...field2 };
  };
};

export const getSubField = (params) => {
  // The getSubField function extracts the value of a nested field
  const [fieldName, subFieldName, subFieldName2] = params?.field
    ?.toString()
    .split(".");
  const field = params?.row[fieldName];
  return field && subFieldName && subFieldName2
    ? field[subFieldName][subFieldName2]
    : field && subFieldName
    ? field[subFieldName]
    : null;
};

export const capitalise = (word) => {
  return word.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};

export const getContrastRatio = (backgroundHexColor) => {
  if (backgroundHexColor) {
    // Remove '#' symbol if present
    if (backgroundHexColor.charAt(0) === "#") {
      backgroundHexColor = backgroundHexColor.substr(1);
    }
    // Convert hex color to RGB
    let r = parseInt(backgroundHexColor.substr(0, 2), 16) / 255;
    let g = parseInt(backgroundHexColor.substr(2, 2), 16) / 255;
    let b = parseInt(backgroundHexColor.substr(4, 2), 16) / 255;

    // Calculate relative luminance
    function getRelativeLuminance(color) {
      return color <= 0.03928
        ? color / 12.92
        : Math.pow((color + 0.055) / 1.055, 2.4);
    }
    let L1 =
      0.2126 * getRelativeLuminance(r) +
      0.7152 * getRelativeLuminance(g) +
      0.0722 * getRelativeLuminance(b);

    // Calculate contrast ratio with black and white
    let contrastWithBlack = (L1 + 0.05) / 0.05;
    let contrastWithWhite = 1 / ((1 + 0.05) / (L1 + 0.05));

    // Determine which contrast is higher
    if (contrastWithBlack >= contrastWithWhite) {
      return "black";
    } else {
      return "white";
    }
  } else {
    return "red";
  }
};

export const tagsFilterOperators = getGridSingleSelectOperators()
  .filter((operator) => operator.value === "isAnyOf")
  .map((operator) => {
    const newOperator = { ...operator };
    const newGetApplyFilterFn = (filterItem, column) => {

      if (!Array.isArray(filterItem?.value) || filterItem?.value?.length < 1) {

        return null;
      }
      return (value) => {
        let isOk = true;

        const matching = value?.some((fv) => {
          return filterItem?.value?.includes(fv?.tag_ref);
        });

        return isOk && matching;
      };
    };
    newOperator.getApplyFilterFn = newGetApplyFilterFn;
    return newOperator;
  });

export const getApplyFilterFnTags = (filter, data) => {
  if (!filter) {
    return null;
  }
  return (value) => {
    if (value) {
      const sg = data?.tags?.find((c) => {
        return c?.tag_name?.toLowerCase().includes(filter);
      });

      return value?.some((tag) => {
        return parseInt(tag?.tag_ref) === parseInt(sg?.tag_ref);
      });
    }
    return false;
  };
};

export const getApplyFilterFnTagBehaviour = (filter, data) => {
  if (!filter) {
    return null;
  }
  return (value) => {
    if (value) {

      const test = renderTagModules(value, data);
      return value?.some((tag) => {
        const isMatch =
          tag?.behaviour?.toLowerCase().includes(filter?.toLowerCase()) ||
          JSON.stringify(tag?.arguments)
            ?.toLowerCase()
            .includes(filter?.toLowerCase()) ||
          test.toLowerCase().includes(filter?.toLowerCase());

        return isMatch;
      });
    }
    return false;
  };
};

export const getNestedValue = (obj, path) => {
  const keys = path.split(".");
  return keys.reduce(
    (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
    obj
  );
};

export function hasNestedKey(obj, keyToFind) {
  // Check if the current object has the key
  if (obj.hasOwnProperty(keyToFind)) {
    return true;
  }

  // Recursively check nested objects
  for (const prop in obj) {
    if (typeof obj[prop] === "object" && obj[prop] !== null) {
      if (hasNestedKey(obj[prop], keyToFind)) {
        return true;
      }
    }
  }

  // Key not found in the object or its nested properties
  return false;
}

export const getApplyFilterFnSalesGroup = (searchTerm, data) => {
  if (!searchTerm) {
    return null;
  }
  return (value) => {
    if (value) {
      const sg = data?.categories?.filter((c) => {
        return c?.salesGroup_name?.toLowerCase().includes(searchTerm);
      });

      if (sg) return sg.some((x) => x?.salesGroup_number === value);
    }
    return false;
  };
};
export const getApplyFilterFnPriceBand = (searchTerm, data) => {
  if (!searchTerm) {
    return null;
  }
  return (value) => {
    if (value) {
      const sg = data?.priceband?.filter((c) => {
        return c?.priceband_name?.toLowerCase().includes(searchTerm);
      });

      if (sg) return sg.some((x) => x?.priceband_number === value);
    }
    return false;
  };
};

export const tagsSortComparator = (tags1, tags2) => {
  return tags1.length - tags2.length;
};

export const getTagValue = (params, item, data, page) => {
  // get original object by row id
  const obj = data[page].find((obj) => obj?.uid === params?.row?.uid);
  if (obj !== undefined) {
    const value = obj[params?.colDef?.masterField][params?.colDef?.field];
    const arr = [];
    value?.map((tagNumber) => {
      tagNumber = data.tags?.filter((newTag) => newTag?.tag_ref === tagNumber);
      if (tagNumber[0] !== undefined) {
        arr.push(tagNumber[0]);
      }
    });
    return arr;
  }
};
export const getTagValueNewGrid = (params, data) => {
  const [fieldName, subFieldName] = params?.field?.toString()?.split(".");
  const field = params?.row[fieldName];

  const val = field[subFieldName];
  if (val !== undefined) {
    const arr = [];
    val?.map((tagNumber) => {
      tagNumber = data?.tags?.filter((newTag) => newTag?.tag_ref === tagNumber);
      if (tagNumber[0] !== undefined) {
        arr.push(tagNumber[0]);
      }
    });
    return arr;
  }
};

export const getListIssues = (params, item, data) => {
  let value;

  const obj = data.screens?.find(
    (obj) => obj?.list_number === params?.row?.list_number
  );

  if (obj !== undefined) {
    if (obj.list_details.ignoreThisList === true) {
      return false;
    }
    const buttons = obj[item?.masterField][item?.dataField2];

    value = buttons?.some(function (button) {
      if (button?.functionType === 1 && button.mx !== 0 && button.my !== 0) {
        return !data?.function?.find(
          (item) => parseInt(item?.function_number) === button?.functionValue
        );
      } else if (
        button?.functionType === 12 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.screens?.find(
          (item) => parseInt(item?.list_number) === button?.functionValue
        );
      } else if (
        button?.functionType === 21 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.items?.find(
          (item) => parseInt(item?.plu_number) === button?.functionValue
        );
      } else if (
        button?.functionType === 3 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.modifier?.find(
          (item) => parseInt(item?.modifier_number) === button?.functionValue
        );
      } else if (
        button?.functionType === 2 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.paymentMethod?.find(
          (item) =>
            parseInt(item.paymentMethod_number) === button?.functionValue
        );
      }
      //  else if (
      // 	button?.functionType === 1 &&
      // 	button.mx !== 0 &&
      // 	button.my !== 0
      // ) {
      // 	return !data?.functions?.find(
      // 		(item) => parseInt(item?.number) === button?.functionValue
      // 	);
      // }
      else if (
        button?.functionType === 20 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.macro?.find(
          (item) => parseInt(item?.macro_number) === button?.functionValue
        );
      } else if (
        button?.functionType === 13 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.presetServers?.find(
          (item) => item?.value === button?.functionValue
        );
      } else {
        return null;
      }
    });
  }
  return value;
};

export const getVariantCount = (value, row, data) => {
  if (row?.list_number) {
    const count = data?.screens?.filter(
      (i) =>
        i.list_isDeleted === 0 &&
        parseInt(i.list_number) === parseInt(row.list_number) &&
        i.list_variant !== 0
    ).length;
    return count;
  } else return null;
};
export const getListIssuesNewDataGrid = (value, row, data) => {
 

  if (row !== undefined) {
    if (row?.ignoreThisList === true) {

      return false;
    }
    value = row?.list_details?.buttons?.some(function (button) {
      if (button?.functionType === 1 && button.mx !== 0 && button.my !== 0) {
        return !data?.function?.find(
          (item) => parseInt(item?.function_number) === button?.functionValue
        );
      } else if (
        button?.functionType === 12 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.screens?.find(
          (item) =>
            parseInt(item?.list_number) === button?.functionValue &&
            item.list_isDeleted === 0
        );
      } else if (
        button?.functionType === 21 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.items?.find(
          (item) =>
            parseInt(item?.plu_number) === button?.functionValue &&
            item.plu_isDeleted === 0
        );
      } else if (
        button?.functionType === 3 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.modifier?.find(
          (item) =>
            parseInt(item?.modifier_number) === button?.functionValue &&
            item.modifier_isDeleted === 0
        );
      } else if (
        button?.functionType === 2 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.paymentMethod?.find(
          (item) =>
            parseInt(item.paymentMethod_number) === button?.functionValue &&
            item.paymentMethod_isDeleted === 0
        );
      }
      //  else if (
      // 	button?.functionType === 1 &&
      // 	button.mx !== 0 &&
      // 	button.my !== 0
      // ) {
      // 	return !data?.functions?.find(
      // 		(item) => parseInt(item?.number) === button?.functionValue
      // 	);
      // }
      else if (
        button?.functionType === 20 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.macro?.find(
          (item) =>
            parseInt(item?.macro_number) === button?.functionValue &&
            item.macro_isDeleted === 0
        );
      } else if (
        button?.functionType === 13 &&
        button.mx !== 0 &&
        button.my !== 0
      ) {
        return !data?.presetServers?.find(
          (item) => item?.value === button?.functionValue
        );
      } else {
        return null;
      }
    });
  }

  return value;
};

export const listIssuesFilterOperator = [
  {
    label: "has issues",
    value: "isEmpty",
    getApplyFilterFn: (filterItem) => {
      return (params) => {
        return params === true;
      };
    },
    requiresFilterValue: false,
  },
];

export const renderTagModules = (tagModuleData, data) => {
  if (!tagModuleData || !Array.isArray(tagModuleData)) {
    return "No data available";
  }
  const formattedText = tagModuleData.map((item, index) => {
    const moduleLookUp = TagConfig(item.behaviour, data);

    if (item.arguments && typeof item.arguments === "object") {
      const keys = Object.keys(item.arguments);
      const formattedArguments = keys.map((key, arrayIndex) => {
        let moduleLookUpArg = "";
        if (moduleLookUp) {
          moduleLookUpArg = moduleLookUp.moduleOptions.find(
            (arg) => arg.option_tag === key
          );
        }
        const value = item.arguments[key];
        let moduleLookUpArgValue = value;
        if (moduleLookUpArg) {
          if (moduleLookUpArg.option_type === "list") {
            moduleLookUpArgValue = moduleLookUpArg.option_values.find(
              (option) => option.value === value
            );
            moduleLookUpArgValue = moduleLookUpArgValue
              ? moduleLookUpArgValue.text
              : "n/a";
          }
        }

        return `${
          moduleLookUpArg ? moduleLookUpArg.option_name : "n/a"
        } - ${moduleLookUpArgValue}`;
      });

      return `${index + 1}. ${
        moduleLookUp ? moduleLookUp.module_name : "n/a"
      } (${formattedArguments.join(", ")})`;
    } else {
      return `${index + 1}. ${item.behaviour} (No arguments)`;
    }
  });

  return formattedText.join("\n");
};

export const numberSort = (v1, v2) => parseInt(v1) - parseInt(v2);

export const currencyFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
});

export const StyledGridOverlay = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  "& .ant-empty-img-1": {
    fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
  },
  "& .ant-empty-img-2": {
    fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
  },
  "& .ant-empty-img-3": {
    fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
  },
  "& .ant-empty-img-4": {
    fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
  },
  "& .ant-empty-img-5": {
    fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
    fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
  },
}));

export function CustomNoRowsOverlay() {
  return (
    <StyledGridOverlay>
      <svg
        width="250"
        height="220"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Typography sx={{ mt: 1 }}>No Rows</Typography>
    </StyledGridOverlay>
  );
}

export const StyledOverlay = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  alignItems: "center",
  justifyContent: "center",
  height: "100%",
}));

export function CustomOverlay() {
  return (
    <StyledOverlay>
      <Player
        autoplay
        loop
        src="https://lottie.host/9c9aa0aa-4590-4005-9036-ae1add04bb1b/Y0WC7l7CqL.json"
        style={{ height: "300px", width: "300px" }}
      >
        {/* <Box>
					<Typography sx={{ textAlign: "center" }}>No Results Found</Typography>
				</Box> */}
        <Controls
          visible={false}
          // buttons={["play", "repeat", "frame", "debug"]}
        />
      </Player>
      <Box>
        <Typography sx={{ textAlign: "center" }}>No Results Found</Typography>
      </Box>
    </StyledOverlay>
  );
}

export const siteOrTag = (type, ref, data) => {
  let index = 0;
  let name = "";
  switch (type.toLowerCase()) {
    case "site":
    case "sites":
      index = data.sites.findIndex((item) => item.site_ref === ref);
      name = index !== -1 ? data.sites[index].site_name : "Unknown Site";

      return name;
    case "tag":
    case "tags":
      index = data.tags.findIndex((item) => item.tag_ref === ref);
      name = index !== -1 ? data.tags[index].tag_name : "Unknown Tag";
      return name + " Tag(" + ref + ")";
    default:
      return "Unknown type";
  }
};

export const modiferDataColumns = (
  priceModifierConfig,
  rows,
  data,
  classes,
  ref,
  priceBandColors,
  siteFilterValue,
  priceBandFilterValue,
  table
) => {
  // WARNING: this code only works with masterField and dataField2 Data Grid Config - will need refactoring to work
  // with the top level field value
  const priceModDebug = false;
  const modiferItems = {};
  const modiferItemsSite = {};
  const modiferItemsPriceBand = {};
  const priceBandFilterData = data?.priceband;

  function getPriceBandName(targetNumber) {
    const foundPriceBand = priceBandFilterData?.find(
      (band) => band?.priceband_number === targetNumber.toString()
    );

    return foundPriceBand
      ? foundPriceBand.priceband_name
      : "no price band found";
  }

  const returnArray = [];
  // build the columns based on sites so that is is sorted
  for (let i = 0; i < data["sites"]?.length; i++) {
    for (let p = 1; p <= 10; p++) {
      const columnName =
        "expandedfield:" +
        priceModifierConfig?.masterField +
        "/" +
        priceModifierConfig?.dataField2 +
        "," +
        '"type":"Site","priceBand":"' +
        p +
        '","ref":"' +
        data["sites"][i].site_ref +
        '"';
      modiferItems[columnName] =
        //eslint-disable-next-line
        data["sites"][i].site_name + " " + "\n" + getPriceBandName(p);

      modiferItemsSite[columnName] = data["sites"][i].site_ref;
      modiferItemsPriceBand[columnName] = p.toString();
    }
  }
  // loop through all the data and see what has a modifer
  for (let i = 0; i < rows?.length; i++) {
    // does the initial nested object exist? if it doesn't then just exit and wait for the row data to update
    if (!hasNestedKey(rows[i], priceModifierConfig.dataField2)) {
      return [];
    }
    const priceModLen =
      typeof rows[i][priceModifierConfig.masterField][
        priceModifierConfig.dataField2
      ] === "object"
        ? rows[i][priceModifierConfig?.masterField][
            priceModifierConfig?.dataField2
          ].length
        : 0;
    // loop through the price modifiers
    for (let j = 0; j < priceModLen; j++) {
      // check if there is a priceBand - but default regardless incase it doesn't exist
      let priceBand = 1; // the default if not price band present
      if (
        "priceBand" in
        rows[i][priceModifierConfig?.masterField][
          priceModifierConfig?.dataField2
        ][j]
      ) {
        priceBand =
          rows[i][priceModifierConfig?.masterField][
            priceModifierConfig?.dataField2
          ][j]["priceBand"];
      }
      // update/add the type/ref so we know it is used
      const fieldRef =
        rows[i][priceModifierConfig?.masterField][
          priceModifierConfig?.dataField2
        ][j]["ref"];
      const columnName =
        "expandedfield:" +
        priceModifierConfig?.masterField +
        "/" +
        priceModifierConfig?.dataField2 +
        "," +
        '"type":"' +
        rows[i][priceModifierConfig?.masterField][
          priceModifierConfig?.dataField2
        ][j]["type"] +
        '",' +
        '"priceBand":"' +
        priceBand +
        '",' +
        '"ref":"' +
        rows[i][priceModifierConfig?.masterField][
          priceModifierConfig?.dataField2
        ][j]["ref"] +
        '"';
      // create the fieldname as the key, and the fieldheads as the value
      const fieldType =
        rows[i][priceModifierConfig?.masterField][
          priceModifierConfig?.dataField2
        ][j]["type"];
      // ----

      if (fieldType === "Site") {
        modiferItems[columnName] =
          siteOrTag(fieldType, fieldRef, data) +
          "\n" +
          getPriceBandName(priceBand);

        // update just in case undefined is returned
        if (typeof modiferItems[columnName] === "undefined") {
          modiferItems[columnName] = "Loading...";
        }
        // add the columnData to the data grid row
        rows[i][columnName] =
          rows[i][priceModifierConfig?.masterField][
            priceModifierConfig?.dataField2
          ][j]["modifier"];
        modiferItemsSite[columnName] = fieldRef;
        modiferItemsPriceBand[columnName] = priceBand;
      }
    }
  }

  // Use the class in your component
  for (let key in modiferItems) {
    if (
      siteFilterValue.indexOf(modiferItemsSite[key].toString()) > -1 &&
      priceBandFilterValue.indexOf(modiferItemsPriceBand[key].toString()) > -1
    ) {

      const selectedPriceBand = priceBandColors.find(
        (pb) =>
          parseInt(pb.priceband_number) === parseInt(modiferItemsPriceBand[key])
      );
      returnArray.push({
        field: key,
        type: "priceNested",
        headerName: modiferItems[key],
        // headerClassName: classes.headerWrap,
        // headerClassName: "pricingHeader",
        renderHeader: (params) => (
          <Typography
            sx={{
              textOverflow: "clip",
              fontSize: 14,
              fontWeight: "200",
              whiteSpace: "normal !important",
              wordWrap: "break-word !important",
              lineHeight: "normal",
              // transform: table === 'history' && 'rotate(-90deg)',
              padding: 0,
              // padding: 5,
              "&:hover": {
                whiteSpace: "normal",
              },
            }}
          >
            {params?.colDef?.headerName}
          </Typography>
        ),
        editable: true,
        sortable: true,
        ref: ref,
        flex: 1,
        minWidth: 80,
        align: "center",
        display: "flex",
        priceBand: modiferItemsPriceBand[key],
        priceBandBackGroundColor: selectedPriceBand
          ? selectedPriceBand.color
          : "red",
        cellClassName: "priceMod",
        valueFormatter: (value) => value && currencyFormatter.format(value),

        renderCell: ({ value }) => (
          <>
            {table !== "history" ? (
              <Typography
                variant="datagrid"
                sx={{
                  width: "100%",
                  flexDirection: "column",
                  height: "100%",
                  display: "flex", // Ensures content takes full space
                  justifyContent: "center",
                  alignItems: "flex-end",
                  pr: 2,
                  // padding: "8px", // Add padding to the cell
                  // Added in for colours in the price band grid abd the get contrast ratio function for the text
                  color: selectedPriceBand
                    ? getContrastRatio(selectedPriceBand.color)
                    : "black",
                  backgroundColor: selectedPriceBand
                    ? selectedPriceBand.color
                    : "none",
                }}
              >
                {value ? currencyFormatter.format(value) : "£"}
              </Typography>
            ) : value ? (
              currencyFormatter.format(value)
            ) : (
              "£"
            )}
          </>
        ),
        renderEditCell: (params) => (
          <Box
            sx={{
              // width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <CustomTextField
              // defaultValue={params.value}
              // label="Ref"
              value={params.value}
              type="price"
              label={null}
              onChange={(e) => {
                const updatedValue = e.target.value;
                ref.current.setEditCellValue({
                  id: params.id,
                  field: params.field,
                  value: updatedValue,
                });
              }}
              origin="datagrid"
            />
          </Box>
        ),
      });
    } else {
    }
  }

  // show the price mod as JSON?
  if (priceModDebug) {
    returnArray.push({
      field: "na",
      masterField: priceModifierConfig.masterField,
      dataField2: priceModifierConfig.dataField2,
      type: "JSON",
      headerName: "priceMod",
      // flex: 1,

      editable: false,
      sortable: false,
      minWidth: 80,

      //ref: sitesRef,
    });
  }

  // --- make an empty field array
  if (returnArray.length === 0) {
    returnArray.push({
      field: "na",
      type: "string",
      headerName: "No Price Modifiers",
      flex: 1,
      // minWidth: 80,
      editable: false,
      sortable: false,
      //ref: sitesRef,
    });
  }

  return returnArray;
};

export function computeMutation(newRow, oldRow) {
  if (newRow !== oldRow) {
    return `Not equal'`;
  }

  return null;
}

export function setSubFieldPermissions(subFieldName1, subFieldName2) {
  // The setSubField function updates a nested field with a new value
  return (params) => {
    const field = { ...params?.row[subFieldName1] };
    field[subFieldName2] = params?.value;
    const field2 = { ...params?.row };
    field2[subFieldName1] = field;
    return { ...field2 };
  };
}

export function getSubFieldPermissions(params) {
  // The getSubField function extracts the value of a nested field
  const [fieldName, subFieldName] = params?.field?.toString().split(".");
  const field = params?.row[fieldName];
  return field ? field[subFieldName] : null;
}

// const saveRow = async(rows, table, token,unsavedChangesRef, setSaveProgress,
// 	setIsSaving,setHasUnsavedRows,blocker,saveProgress) => {
// 	const config = {
// 		headers: { Authorization: `Bearer ${token}` },
// 	};
//   return   axios
//   .post(`${API_ENDPOINTS[table]}/?debug=true`, {updates: rows}, config).then(function (response) {

// 		const rowsToDelete = Object.values(
// 			unsavedChangesRef?.current?.unsavedRows,
// 		  ).filter((row) => { return rows.includes(row)})

// 		  if (rowsToDelete?.length > 0) {
// 			rowsToDelete.forEach((row) => {
// 				delete unsavedChangesRef?.current?.unsavedRows[row?.uid]
// 				delete unsavedChangesRef?.current?.rowsBeforeChange[row?.uid]						})
// 		  }
// 		  response.data[table].map((newRow)=>
// 		  newRow[`uid`] = newRow[`${table}_uid`])
// return response

// })
// .catch(function (error) {
// 	console.log(error)

// 		setIsSaving(false)
// 		return error
// });
//   };

function loadingBarStatus(current, max, setSaveProgress) {
  setSaveProgress({ openDialog: true, progress: (current / max) * 100 });
}

//  async function axiosWrapper (chunk, table, token,unsavedChangesRef, setSaveProgress,setIsSaving,setHasUnsavedRows,blocker, saveProgress){
//     let ItemPromise = saveRow(chunk,table, token, unsavedChangesRef, setSaveProgress,setIsSaving, setHasUnsavedRows,blocker)
//     let axiosResult = await ItemPromise

// if(axiosResult.status === 200) {
//     return axiosResult.data[table]
// }

//     return axiosResult
// }

// export async function processRowUpdateUtilSave (newRow,isNew, setIsSaving,token, setSaveProgress,table,unsavedChangesRef,setData, setHasUnsavedRows, setSelectedRowsData,contextName, blocker,setModalVisible, data, dispatch,saveProgress, num,setHighestProcessedUID){

// 	const collapseFieldData = [];
// 	let fieldLevel0 = "";
// 	let fieldLevel1 = "";
// 	newRow.map((updatedRow) => {
// 		Object.keys(updatedRow).forEach(function (key) {
// 		if (key.substring(0, 14) === "expandedfield:") {
// 			// find the field name
// 			const findComma = key.search(",");
// 			const fieldName = key.substring(14, findComma);
// 			// extract the source field
// 			const fieldLevelSpliter = fieldName.search("/");
// 			fieldLevel0 = fieldName.substring(0, fieldLevelSpliter);
// 			fieldLevel1 = fieldName.substring(fieldLevelSpliter + 1);
// 			// check the field has a value (i.e. not undefined)
// 			if (typeof updatedRow[key] !== "undefined") {
// 				let modValue = null;
// 				switch (typeof updatedRow[key]) {
// 					case "number":
// 						modValue = updatedRow[key];
// 						break;
// 					case "string":
// 						modValue = JSON.stringify(parseFloat(updatedRow[key]));
// 						break;
// 					default:
// 						modValue = null;
// 				}
// 				const fieldValue =
// 					"{" +
// 					key.substring(findComma + 1) +
// 					',"modifier":' +
// 					modValue +
// 					"}";

// 				if (
// 					modValue !== "null" &&
// 					modValue !== null &&
// 					typeof modValue !== "undefined"
// 				) {
// 					collapseFieldData.push(JSON.parse(fieldValue));
// 				}
// 			}
// 		}
// 	});
// 	return updatedRow
// })
// 	if (fieldLevel0 !== "" && fieldLevel1 !== "") {
// 		newRow[0][fieldLevel0][fieldLevel1] = collapseFieldData;
// 	}

// 			delete (newRow[0].plu_details.salesGroup)

// 	const chunk = (arr, size) =>
// 		Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
// 		  arr.slice(i * size, i * size + size)
// 		);

// 	const chunks = chunk(newRow, 50)
// 	const progressLength = chunks.length
//     const promiseArray = chunks.map(Item => {
//         const result = axiosWrapper(Item, table, token,unsavedChangesRef, setSaveProgress,setIsSaving, num, progressLength,setHasUnsavedRows,blocker,saveProgress).then((res) => {
// 			console.log(res)

// 			loadingBarStatus(num++, progressLength,setSaveProgress)
// // if(result.status === 200){

// // }
// 		return res
//     })
// 	return result
// })

//     const ArrayOfResults = await Promise.all(promiseArray)
// 	.then((res)=> {
// return res.filter((i)=> {
// 	return Array.isArray(i)
// }).flat()
// 	}
// 	).catch((err)=>{
// 		return err
// 	})
// 	console.log(ArrayOfResults)
// 	const maxUID =  ArrayOfResults.reduce(function(prev, current) {
// 		return (prev && prev.uid > current.uid) ? prev.uid : current.uid
// 	  }) //returns object
// 	  console.log(maxUID)
// 	//   setHighestProcessedUID(maxU)

// 	  const updatedData = {
// 						...data,
// 						[contextName]: data[contextName].map((row)=>
// 							{ const index = ArrayOfResults.findIndex((item) => parseInt(row[`${table}_ref`]) === parseInt(item[`${table}_ref`]) && row[`${table}_isDeleted`] === 0)
// 						return index > -1 ? ArrayOfResults[index] :  row
// 					})
// 					};
// 					return updatedData
// }

export async function processRowUpdateUtil(
  newRow,
  isNew,
  token,
  setSaveProgress,
  table,
  unsavedChangesRef,
  setData,
  setSelectedRowsData,
  data,
  contextName,
  num,
  bulk
) {
  const collapseFieldData = [];
  let fieldLevel0 = "";
  let fieldLevel1 = "";
  newRow.map((updatedRow) => {
    Object.keys(updatedRow).forEach(function (key) {
      if (key.substring(0, 14) === "expandedfield:") {
        // find the field name
        const findComma = key.search(",");
        const fieldName = key.substring(14, findComma);
        // extract the source field
        const fieldLevelSpliter = fieldName.search("/");
        fieldLevel0 = fieldName.substring(0, fieldLevelSpliter);
        fieldLevel1 = fieldName.substring(fieldLevelSpliter + 1);
        // check the field has a value (i.e. not undefined)
        if (typeof updatedRow[key] !== "undefined") {
          let modValue = null;
          switch (typeof updatedRow[key]) {
            case "number":
              modValue = updatedRow[key];
              break;
            case "string":
              modValue = JSON.stringify(parseFloat(updatedRow[key]));
              break;
            default:
              modValue = null;
          }
          const fieldValue =
            "{" +
            key.substring(findComma + 1) +
            ',"modifier":' +
            modValue +
            "}";

          if (
            modValue !== "null" &&
            modValue !== null &&
            typeof modValue !== "undefined"
          ) {
            collapseFieldData.push(JSON.parse(fieldValue));
          }
        }
      }
    });
    return updatedRow;
  });
  if (fieldLevel0 !== "" && fieldLevel1 !== "") {
    newRow[0][fieldLevel0][fieldLevel1] = collapseFieldData;
  }

  // delete (newRow[0].plu_details.salesGroup)
  const BATCH_SIZE = 25;

  const updatedItemsMap = new Map(
    newRow.map((item) => [item.plu_number, item])
  );

  // Keep track of successfully saved PLU numbers
  const successfullySavedPLUs = [];
  const failedBatches = [];
  // Convert current items into a Map for fast updates
  const progressLength = newRow.length / BATCH_SIZE;
  for (let i = 0; i < newRow.length; i += BATCH_SIZE) {
    const batch = newRow.slice(i, i + BATCH_SIZE);

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const res = await axios.post(
        `${API_ENDPOINTS[table]}/?debug=true`,
        { updates: batch },
        config
      );
      if (res.status !== 200) throw new Error("Batch failed");
      const updatedItems = await res.data[table]; // Assume array of saved items
      updatedItems.forEach((item) => {
        item[`uid`] = item[`${table}_uid`];
        updatedItemsMap.set(item.plu_number, item);
        successfullySavedPLUs.push(item);
      });
    } catch (err) {
      console.error("Batch failed:", err);
      failedBatches.push(...batch); // Save failed items for later
    }
    if (bulk) {
      loadingBarStatus(
        num++,
        progressLength < 1 ? 1 : progressLength,
        setSaveProgress
      );
    }
  }

  // const newItems = Array.from(updatedItemsMap.values());
  let newUnsavedChanges = newRow.filter(
    (item) =>
      !successfullySavedPLUs.find(
        (i) => parseInt(i.plu_number) === parseInt(item.plu_number)
      )
  );

  // Step 3: If any batches failed, fetch all items and compare plu_UID
  if (failedBatches.length > 0) {
    try {
      const api = `${APP_URL}/api/pos/getNextSetFromCache/?table=${table}&uid=0&setSize=9999`;
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const res = await axios.get(api, config);
      const allItems = await res.data.rows;
      const allItemsMap = new Map(
        allItems.map((item) => [item.plu_number, item])
      );

      // console.log('allItemsmap',allItemsMap)
      newUnsavedChanges.forEach((item) => {
        const fresh = allItemsMap.get(item.plu_number);
        // console.log(fresh, item)
        if (fresh && parseInt(fresh.plu_uid) > parseInt(item.plu_uid)) {
          // console.log(item)
          successfullySavedPLUs.push(item);
        }
      });

      //   const fresh = allItemsMap.get(item.plu_number);
      //   return !fresh || fresh.plu_uid <= item.plu_uid;
      //   successfullySavedPLUs.add(item);
    } catch (err) {
      console.error("Error fetching all items after failed batches:", err);
    }
  }

  const rowsToDelete = Object.values(
    unsavedChangesRef?.current?.unsavedRows
  ).filter((row) => {
    return successfullySavedPLUs.find((i) => row.plu_number === i.plu_number);
  });

  if (rowsToDelete?.length > 0) {
    rowsToDelete.forEach((row) => {
      delete unsavedChangesRef?.current?.unsavedRows[row?.uid];
      delete unsavedChangesRef?.current?.rowsBeforeChange[row?.uid];
    });
  }

  setSelectedRowsData([]);
  const updatedData = {
    ...data,
    [contextName]: isNew
      ? [...data[contextName], ...successfullySavedPLUs]
      : data[contextName].map((row) => {
          const index = successfullySavedPLUs.findIndex(
            (item) =>
              parseInt(row[`${table}_ref`]) ===
                parseInt(item[`${table}_ref`]) &&
              row[`${table}_isDeleted`] === 0
          );
          return index > -1 ? successfullySavedPLUs[index] : row;
        }),
  };
  setData(updatedData);

  return updatedData;
}

export const getTogglableColumns = (columns) => {
  return columns
    .filter(
      (column) =>
        column.field !== "tagExport" &&
        column.field !== "__check__" &&
        column.field !== "Actions" &&
        column.allowToggle !== false
    )
    .map((column) => column.field);
};

export const handleRowEditStop = (params, event) => {
  if (params.reason === GridRowEditStopReasons.rowFocusOut) {
    event.defaultMuiPrevented = true;
  }
};

export const onDiscard = async (unsavedChangesRef, ref) => {
  const changes = Object.values(unsavedChangesRef.current.rowsBeforeChange).map(
    (row, i) => {
      return ref.current.updateRows([row]);
    }
  );
  return changes;
};

export const openDelete = (row, data, gridList, setOpen) => () => {
  const ids = [row.id];
  const appears = appearsOn(data.screens, row.row.plu_number);
  let variants;
  if (gridList.gridPage === "screens") {
    variants = data.screens?.filter(
      (i) =>
        parseInt(i?.list_number) === parseInt(row?.row?.list_number) &&
        i?.list_isDeleted === 0 &&
        i?.list_variant !== 0
    );
    variants.map((i) => ids.push(parseInt(i?.list_uid)));
  }

  const users = data?.users?.filter((user) => {
    return (
      parseInt(user?.user_details?.userType) ===
      parseInt(row?.row?.userType_ref)
    );
  });

  setOpen({
    status: true,
    id: ids,
    msg:
      gridList.gridPage === "items" && appears.length > 0
        ? `Deleting this item will affect buttons on the following screens:`
        : gridList.gridPage === "screens" && variants.length > 0
        ? `Deleting this screen will also delete it's associated variants:`
        : gridList.gridPage === "userTypes" && users.length > 0
        ? "Deleting this user type will affect the following users and may cause issues."
        : null,
    lists:
      gridList.gridPage === "items" && appears.length > 0
        ? appears
        : gridList.gridPage === "screens" && variants.length > 0
        ? variants
        : gridList.gridPage === "userTypes" && users.length > 0
        ? users
        : null,
  });
};

const handleNo = (promiseArguments, setPromiseArguments) => {
  const { oldRow, resolve } = promiseArguments;
  resolve(oldRow);
  setPromiseArguments(null);
};

const handleYes = async (
  promiseArguments,
  setPromiseArguments,
  handleRevertItem
) => {
  const { newRow, oldRow, reject, resolve } = promiseArguments;
  try {
    const response = await handleRevertItem(newRow);
    resolve(response);
    setPromiseArguments(null);
  } catch (error) {
    reject(oldRow);
    setPromiseArguments(null);
  }
};

export const renderConfirmDialog = (
  noButtonRef,
  promiseArguments,
  setPromiseArguments,
  handleRevertItem
) => {
  if (!promiseArguments) {
    return null;
  }
  const handleEntered = () => {};

  return (
    <Dialog
      maxWidth="xs"
      TransitionProps={{ onEntered: handleEntered }}
      open={!!promiseArguments}
    >
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent
        dividers
      >{`Pressing 'Yes' will reinstate this row.`}</DialogContent>
      <DialogActions>
        <Button ref={noButtonRef} onClick={handleNo(promiseArguments)}>
          No
        </Button>
        <Button
          onClick={handleYes(
            promiseArguments,
            setPromiseArguments,
            handleRevertItem
          )}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const handleCancelClick =
  (id, setRowModesModel, rows, setRows) => () => {
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));

    const editedRow = rows.find((row) => parseInt(row.uid) === id);
    if (editedRow?.isNew) {
      setRows(rows.filter((row) => parseInt(row.uid) !== id));
    }
  };

export const actionOptions = (
  row,
  gridList,
  option,
  userPermission,
  handleEditClick,
  data,
  setOpen,
  handleNavigate,
  setRowModesModel,
  handleSaveClick,
  processRevert,
  setHistoryModalOpen,
  rows,
  setRows
) => {
  switch (option) {
    case "Edit":
      return (
        <AccessControl
          userPermissions={userPermission}
          unallowedPermissions={{
            page: gridList.gridPage,
            action: "edit",
            // strict: false,
            strict:
              gridList.gridPage === "modifiers" ||
              gridList.gridPage === "analysisCategories" ||
              gridList.gridPage === "macros" ||
              gridList.gridPage === "pricebands" ||
              gridList.gridPage === "paymentMethods" ||
              gridList.gridPage === "users" ||
              gridList.gridPage === "userTypes" ||
              gridList.gridPage === "policies"
                ? true
                : false,
          }}
          renderNoAccess={() => <></>}
        >
          <GridTooltip label="Edit">
            <EditIcon
              fontSize="small"
              className="tableControl"
              onClick={(event) => {
                event.stopPropagation(); // Prevent the row click event from firing
                handleEditClick({ id: row.id, row: row }, event);
              }}
            />
          </GridTooltip>
        </AccessControl>
      );
    case "Delete":
      return (
        <AccessControl
          userPermissions={userPermission}
          unallowedPermissions={{
            page: gridList.gridPage,
            action: "delete",
            strict:
              gridList.gridPage === "modifiers" ||
              gridList.gridPage === "analysisCategories" ||
              gridList.gridPage === "macros" ||
              gridList.gridPage === "pricebands" ||
              gridList.gridPage === "paymentMethods" ||
              gridList.gridPage === "permissions" ||
              gridList.gridPage === "configuration" ||
              gridList.gridPage === "users" ||
              gridList.gridPage === "userTypes" ||
              gridList.gridPage === "policies"
                ? true
                : false,
          }}
          renderNoAccess={() => <></>}
        >
          <GridTooltip label="Delete">
            <DeleteIcon
              fontSize="small"
              className="tableControl"
              onClick={openDelete(row, data, gridList, setOpen)}
            />
          </GridTooltip>
        </AccessControl>
      );
    case "More":
      return (
        <GridTooltip label="More">
          <ArrowForwardIcon
            fontSize="small"
            className="tableControl"
            onClick={handleNavigate(row)}
          />
        </GridTooltip>
      );
    case "Cancel":
      return (
        <GridActionsCellItem
          icon={<CancelIcon fontSize="inherit" />}
          label="Cancel"
          onClick={handleCancelClick(row.id, setRowModesModel, rows, setRows)}
          color="inherit"
        />
      );
    case "Save":
      return (
        <GridActionsCellItem
          icon={
            <>
              {/* <LightTooltip title="Save"> */}
              <SaveIcon fontSize="inherit" />
              {/* </LightTooltip> */}
            </>
          }
          label="Save"
          onClick={handleSaveClick(row.id)}
          // className="tableControl"
        />
      );
    case "NoEdit":
      return (
        <GridActionsCellItem
          icon={<EditOffIcon fontSize="inherit" />}
          label="Uneditable"
          color="inherit"
          className="tableControl"
        />
      );
    case "Reinstate":
      return (
        <AccessControl
          userPermissions={userPermission}
          unallowedPermissions={{
            page: gridList.gridPage,
            // allow: false,
            action: "undelete",
            strict: true,
          }}
          renderNoAccess={() => <></>}
        >
          <GridTooltip label="Reinstate">
            <UpdateIcon
              fontSize="small"
              className="tableControl"
              onClick={(event) => {
                event.stopPropagation();
                processRevert(row.id);
              }}
            />
          </GridTooltip>
        </AccessControl>
      );
    case "History":
      return (
        <GridTooltip label="History">
          <HistoryIcon
            fontSize="small"
            className="tableControl"
            onClick={(event) => {
              event.stopPropagation();
              setHistoryModalOpen({ open: true, row: row });
            }}
          />
        </GridTooltip>
      );
    case "Hidden":
      return <></>;

    default:
  }
};

export const handleMultiCheckBoxSelect = (
  gridList,
  selectedRowsData,
  userPermission,
  setOpenDialog
) => {
  if (gridList.checkBoxDelete === true) {
    const displayButton = selectedRowsData.length === 0 ? false : true;
    return (
      <>
        <AccessControl
          userPermissions={userPermission}
          unallowedPermissions={{
            page: gridList.gridPage,
            // allow: false,
            action: "delete",
            strict:
              gridList.gridPage === "modifiers" ||
              gridList.gridPage === "analysisCategories" ||
              gridList.gridPage === "macros" ||
              gridList.gridPage === "pricebands" ||
              gridList.gridPage === "paymentMethods" ||
              gridList.gridPage === "permissions" ||
              gridList.gridPage === "configuration" ||
              gridList.gridPage === "users" ||
              gridList.gridPage === "userTypes" ||
              gridList.gridPage === "policies"
                ? true
                : false,
          }}
          renderNoAccess={() => <></>}
        >
          {selectedRowsData.length > 0 ? (
            <Button
              onClick={() => setOpenDialog(true)}
              disabled={!displayButton}
              startIcon={<CheckBoxIcon color={Colours.gsblue} size={30} />}
              size="medium"
            >
              {selectedRowsData.length > 1
                ? `Delete ${selectedRowsData.length} rows`
                : "Delete row"}
            </Button>
          ) : null}
        </AccessControl>
      </>
    );
  }
};

export const onSubmitBulkPriceChange = async (
  watchPercentage,
  watchFixedAmount,
  percentAmount,
  increaseDecrease,
  fixedAmount,
  watchRound,
  roundTo,
  roundDirection,
  selectedRowsData,
  unsavedChangesRef,
  rows,
  priceBandFilterValue,
  siteFilterValue,
  processRowUpdateBulk,
  ref
) => {
  const updatedRows = selectedRowsData.map((row, i) => {
    const oldRow = unsavedChangesRef.current.unsavedRows[row]
      ? unsavedChangesRef.current.unsavedRows[row]
      : cloneDeep(rows?.find((x) => parseInt(x?.uid) === parseInt(row)));

    let newRow = cloneDeep(oldRow);
    newRow.plu_details.price = getUpdatedModPrice(
      newRow?.plu_details?.price,
      watchPercentage,
      watchFixedAmount,
      percentAmount,
      increaseDecrease,
      fixedAmount,
      watchRound,
      roundTo,
      roundDirection
    );
    if (
      newRow?.plu_details?.priceModifiers &&
      newRow?.plu_details?.priceModifiers?.length > 0
    ) {
      newRow?.plu_details?.priceModifiers.map((mod) => {
        if (
          priceBandFilterValue.includes(mod?.priceBand) &&
          siteFilterValue.includes(mod?.ref)
        ) {
          mod.modifier = getUpdatedModPrice(
            mod.modifier,
            watchPercentage,
            watchFixedAmount,
            percentAmount,
            increaseDecrease,
            fixedAmount,
            watchRound,
            roundTo,
            roundDirection
          );
          newRow[
            `expandedfield:plu_details/priceModifiers,"type":"Site","priceBand":${JSON.stringify(
              mod.priceBand
            )},"ref":${JSON.stringify(mod.ref)}`
          ] = mod.modifier;
        }
        return mod;
      });
    }
    processRowUpdateBulk(newRow, oldRow);

    ref.current.updateRows([newRow]);

    return newRow;
  });
  return updatedRows;
};

export const singleDataFetch = async (token, table, data, setData) => {
  const api = `${APP_URL}/api/pos/getNextSetFromCache/?table=${table}&uid=0&setSize=9999`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const response = await axios.get(api, config);
  const res = await response?.data?.rows;
  // setData({
  // 	...data,
  // 	items: res
  // })
  return res;
};
